import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { installReleaseRecovery, markReleaseHealthy, recoverFromStaleRelease } from '@/lib/release-recovery';
import './styles.css';

installReleaseRecovery();

const app = createApp(App).use(createPinia()).use(router);
app.mount('#app');

void router.isReady()
  .then(() => markReleaseHealthy())
  .catch((error: unknown) => {
    recoverFromStaleRelease(error, window.location.pathname + window.location.search + window.location.hash);
  });
